export default __webpack_public_path__ + "i18n/translations/translation-pl.fe8553a9.json";